/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespContainer_domesticDeliveryOptions = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_domesticDeliveryOptions",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_domesticDeliveryOptions",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_domesticDeliveryOptions",
      "args": null
    }
  ],
  "type": "ShipmentQuoteConnection"
};

module.exports = fragment;
